module.exports = __webpack_public_path__ + "img/programme6.3e4f0bc1.png";